import type { PropsWithChildren } from 'react'
import React from 'react'
import type { HTMLXStyledProps } from '../../system'
import { forwardRef } from '../../system'
import {
  MoteCardMediumContainerInner,
  MoteCardMediumContainerRoot
} from './MoteCardMediumContainer.styles'

export const MoteCardMediumContainer = forwardRef<
  PropsWithChildren<HTMLXStyledProps<'div'>>,
  'div'
>((props, ref) => {
  const { children, ...rest } = props
  return (
    <MoteCardMediumContainerRoot ref={ref} {...rest}>
      <MoteCardMediumContainerInner>{children}</MoteCardMediumContainerInner>
    </MoteCardMediumContainerRoot>
  )
})
